/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const initialState = {
  performDisputeResolutionObj: {},
  planType: [],
  selectedPlanType: '',
  rebateProgram: [],
  errorMsgClaim: [],
  rebateProgramName: {},
  quarterFrom: '',
  providerSelectionValue: 'Ineligible',
  providerIdValue: '',
  isAllineligibleProviderSelected: false,
  providerInfo: [],
  providerList: [],
  referenceData: [],
  printOptionValue: 'Summary',
  referenceDataSelectedValue: '05 | Medicaid',
  providerWithIdValue: [],
  menuNameValue: '',
  selectRowIndex: null,
  providerGrid: '',
  providerGridData: '',
  displayObj: {
    rebateProgramName: {},
    quarterFrom: '',
    providerInfo: [],
    printOptionValue: 'Summary',
    providerWithIdValue: [],
    referenceDataSelectedValue: '05 | Medicaid',
    providerSelectionValue: 'Ineligible',
    providerGridData: '',
  },
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPLAY_OBJ_CLAIM:
      return { ...state, performResolutionObj: action.screenData };
    case actionTypes.GET_ERROR_MSG_CLAIM:
      return { ...state, errorMsgClaim: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA_CLAIM:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_CLAIM:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_FROM_CLAIM:
      return { ...state, quarterFrom: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME_CLAIM:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.SET_PROVIDER_REFERENCE_CLAIM:
      return { ...state, referenceData: action.payload };
    case actionTypes.SET_PROVIDER_LIST_CLAIM:
      return { ...state, providerList: action.payload };
    case actionTypes.SET_DISPLAY_OBJ_CLAIM:
      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.SET_PROVIDER_DATA_CLAIM:
      let displayObj = {
        ...state.displayObj,
        providerInfo: action.payload,
      };
      return { ...state, providerInfo: action.payload, displayObj };

    case actionTypes.SET_PROVIDER_SELECTION_CLAIM:
      return { ...state, ...action.payload };
    case actionTypes.SET_PROVIDER_GRID_DATA_CLAIM:
      let displayObj1 = {
        ...state.displayObj,
        providerGridData: action.payload,
      };
      return {
        ...state,
        providerGridData: action.payload,
        displayObj: displayObj1,
      };
    // return { ...state, providerGridData: action.payload };
    case actionTypes.SET_REFRESH_DATA_CLAIM:
      return {
        ...state,
        performDisputeResolutionObj: {},
        planType: [],
        selectedPlanType: '',
        rebateProgram: [],
        errorMsgClaim: [],
        rebateProgramName: {},
        quarterFrom: '',
        providerSelectionValue: 'Ineligible',
        providerIdValue: '',
        isAllineligibleProviderSelected: false,
        providerInfo: [],
        providerList: [],
        referenceData: [],
        printOptionValue: 'Summary',
        referenceDataSelectedValue: '05 | Medicaid',
        providerWithIdValue: [],
        menuNameValue: '',
        selectRowIndex: null,
        providerGrid: '',
        providerGridData: '',
      };

    case actionTypes.SET_PAGINATION_INDEX_PROVIDER_CLAIM_LISTING:
      return {
        ...state,
        countValue: action.payload,
      };
    case actionTypes.SET_DISPLAY_DATA_CLAIM:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    default:
      return state;
  }
};
export default reducer;
